import "./styles/home-styles.css";
import React, { useEffect, useState } from "react";
//Assets
//Components
import Navbar from "../../components/navbar/navbar.jsx";
import ButtonLink from "../../components/ButtonLink/ButtonLink.jsx";
import AboutHome from "./AboutHome.jsx";
import WelcomeHome from "./WelcomeHome.jsx";
import ServicesHome from "./ServicesHome.jsx";
import Footer from "../../components/footer/Footer.jsx";
import ProgressBarRunning from "../../components/ProgressBarRunning/ProgressBarRunning.jsx";
import Testiomonials from "./Testimonials.jsx";
import CarouselHome from "./CarouselHome.jsx";
import PreviewApp from "./PreviewApp.jsx";
import PreviewRoutes from "./PtrviewRoutes.jsx";
import { TbPointFilled } from "react-icons/tb";
import Loading from "../../components/Loading/Loading.jsx";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
// import { useNavigation } from "react-router-dom";

const Home = () => {
  const [loading, setLoading] = useState(false);
  const { userType } = useSelector((state) => state.userReducer);
  const { isAuthenticated } = useSelector((state) => state.authReducer);
  const navigation = useNavigate();
  const onClick = () => {
    if (isAuthenticated) {
      if (userType === "user") {
        navigation("/dashboard/history");
      } else {
        toast.error(
          "¡Debes iniciar sesión como Runner para acceder a esta sección!"
        );
      }
    } else {
      navigation("/auth");
    }
  };

  return (
    <>
      <div>
        <Loading loading={loading} />
        <div className="container_home_bg">
          <Navbar />
          <div className="container_content">
            <div className="d-flex justify-content-center flex-column">
              <h1 className="title animate__animated animate__backInLeft animate__slow">
                ¿Qué es Radaria y qué beneficios tiene?
              </h1>
              <div className="d-flex gap-3">
                <p className="fs-5 fw-semibold  ">
                  <TbPointFilled />
                  Conéctate.
                </p>
                <p className="fs-5 fw-semibold  ">
                  <TbPointFilled />
                  Entrena.
                </p>
              </div>
              <p className="animate__animated animate__backInLeft animate__slow">
                Alcanza tu meta con el acompañamiento ideal: encuentra clubs de
                corredores, accede a entrenadores personales, fisioterapeutas,
                nutriólogos y psicólogos, y obtén herramientas diseñadas para
                mejorar tu rendimiento. Además, descubre rutas seguras y
                personalizadas en tiempo real con nuestra app.
              </p>
              <div className="d-flex">
                <button
                  onClick={onClick}
                  className={`btn button-link ${`btn-primary active animate__animated animate__pulse animate__infinite infinite `}  m-2 ps-4 pe-4 `}
                >
                  ¡Vamos!
                </button>

                <ButtonLink link="/about-us" Text="Más..." isAvctive={false} />
              </div>
            </div>
          </div>
          <div className="d-flex container_usersSign ">
            <div className="d-flex flex-column align-items-end">
              <div className="number_users animate__animated animate__swing animate__infinite ">
                <p>+500</p>
              </div>
              <p className="d-flex ">Usuarios se han inscrito.</p>
            </div>
          </div>
        </div>
        <div className="content bg-black">
          <WelcomeHome setLoading={setLoading} />
          <AboutHome />
          <ServicesHome />
          <PreviewApp />
          <CarouselHome />
          <PreviewRoutes />
          <ProgressBarRunning />
          <Testiomonials />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Home;
